import clsx from 'clsx';

import { ItemProps } from '@@/form-components/InputList';
import { InputGroup } from '@@/form-components/InputGroup';

export function RangeItem({
  item,
  onChange,
  index,
  label,
  size = 'small',
  className = '',
}: ItemProps<{ min: number; max: number }> & {
  label: string;
  size?: 'small' | 'large';
  className?: string;
}) {
  return (
    <div className={clsx('flex gap-2', className)}>
      <InputGroup
        size="small"
        className={clsx(size === 'small' ? 'w-24' : 'w-48')}
      >
        <InputGroup.Addon>Min</InputGroup.Addon>
        <InputGroup.Input
          type="number"
          className="form-control"
          value={item.min}
          onChange={(e) =>
            onChange({ ...item, min: parseInt(e.target.value, 10) })
          }
          data-cy={`${label}-range-${index}-min`}
        />
      </InputGroup>
      <InputGroup
        size="small"
        className={clsx(size === 'small' ? 'w-24' : 'w-48')}
      >
        <InputGroup.Addon>Max</InputGroup.Addon>
        <InputGroup.Input
          type="number"
          className="form-control"
          value={item.max}
          onChange={(e) =>
            onChange({ ...item, max: parseInt(e.target.value, 10) })
          }
          data-cy={`${label}-range-${index}-max`}
        />
      </InputGroup>
    </div>
  );
}
